import { render, staticRenderFns } from "./action-button-small.vue?vue&type=template&id=6d31594f&scoped=true&"
import script from "./action-button-small.vue?vue&type=script&lang=js&"
export * from "./action-button-small.vue?vue&type=script&lang=js&"
import style0 from "./action-button-small.vue?vue&type=style&index=0&id=6d31594f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d31594f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d31594f')) {
      api.createRecord('6d31594f', component.options)
    } else {
      api.reload('6d31594f', component.options)
    }
    module.hot.accept("./action-button-small.vue?vue&type=template&id=6d31594f&scoped=true&", function () {
      api.rerender('6d31594f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/action-button-small.vue"
export default component.exports